import * as React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Modal, Button } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import { SavedDiscountAction, showDeleteActionConfirmationModal, getSavedDiscountActions, DeleteDiscountActionConfirmationForm, getDiscountActionIdToDelete } from "app/pages/DiscountEditor/modules/DiscountActions";
import { cancelShowDeleteActionConfirmation, deleteDiscountAction } from 'app/pages/DiscountEditor/actions';
import { DiscountActionTypeTarget } from 'app/shared/model';

type InternalProps = StateProps & DispatchProps; 

interface StateProps {
    isOpen: boolean, 
    discountAction: SavedDiscountAction|undefined
}

interface DispatchProps {
    onCancel: () => void, 
    onDelete: (action: SavedDiscountAction|undefined) => void
}

const DeleteDiscountActionConfirmationModal = (props: InternalProps) => (
    <Modal 
           open={props.isOpen} 
           onCancel={props.onCancel}
           title="Delete action"
           footer={[
               <Button key="cancel" onClick={props.onCancel}>Cancel</Button>,
               <Button key="delete" danger icon={<DeleteOutlined />} onClick={() => props.onDelete(props.discountAction)}>Delete</Button>
           ]}>
      {getDeleteMessage(props)}
    </Modal>
  )

function getDeleteMessage(props: InternalProps) : string { 
    return 'Are you sure you want to delete ' +
         (props.discountAction !== undefined
            ? 'this \'' + DiscountActionTypeTarget.FromEnum(props.discountAction.target.type).LongName + '\' action?' 
            : 'this action?'); 
}

const mapStateToProps = (state:any, ownProps: {}) : StateProps => {
    const idToDelete = getDiscountActionIdToDelete(state);
    const discountAction = getSavedDiscountActions(state).find(x => x.id == idToDelete); 

    return { 
        isOpen: showDeleteActionConfirmationModal(state), 
        discountAction: discountAction
    };
}
  
const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>) : DispatchProps => {
    return {
        onCancel: () => dispatch(cancelShowDeleteActionConfirmation()), 
        onDelete: (action: SavedDiscountAction|undefined) => dispatch(deleteDiscountAction(action != undefined ? action.id : ''))      
    }; 
}
  
export default connect(mapStateToProps, mapDispatchToProps)(DeleteDiscountActionConfirmationModal);